/**
 * PsicoSalud — Utilidades para saludo segun hora del dia.
 *
 * El saludo del dashboard no debe quedar fijo en "Buenos dias" cuando ya
 * es de tarde o de noche. Esta funcion mapea la hora local del navegador
 * (la del usuario, no la del servidor) a una de tres etiquetas:
 *
 *   - morning   05:00 - 11:59  Buenos dias
 *   - afternoon 12:00 - 18:59  Buenas tardes
 *   - evening   19:00 - 04:59  Buenas noches
 *
 * Los cortes siguen la convencion en espaol peninsular / rioplatense
 * que usa el sistema de salud: 12 = tarde, 19 = noche. Si el usuario
 * tiene otra referencia cultural, la franja puede ajustarse via prop.
 */
export type GreetingPeriod = 'morning' | 'afternoon' | 'evening';

export function getGreetingPeriod(hour: number = new Date().getHours()): GreetingPeriod {
  if (hour < 5) return 'evening';
  if (hour < 12) return 'morning';
  if (hour < 19) return 'afternoon';
  return 'evening';
}